// v2.14.4 — Modale pricing Pro (4 tiers comparatifs).
// Réutilise POST /api/payments/initiate (CinetPay mock existant depuis v2.11.0).
// Stocke le tier choisi en localStorage.civ_ai_user_tier après "souscription" mockée.

import { useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

const TIER_COLORS = {
  partner: "#A855F7",
  premium: "#F59E0B",
  basic: "#3B82F6",
  free: "#64748B",
};

const TIERS = [
  {
    id: "free",
    name: "Free",
    price_fcfa: 0,
    price_label: "0 FCFA",
    perks: [
      "Adresse AYA gratuite",
      "1 commerce listé",
      "Sans badge sponsorisé",
      "Support email standard",
    ],
  },
  {
    id: "basic",
    name: "Basic",
    price_fcfa: 5000,
    price_label: "5 000 FCFA/mois",
    perks: [
      "Tout du Free",
      "Badge Basic dans le chat",
      "Priorité moyenne dans search",
      "3 commerces / 5 adresses",
    ],
  },
  {
    id: "premium",
    name: "Premium",
    price_fcfa: 15000,
    price_label: "15 000 FCFA/mois",
    highlight: true,
    perks: [
      "Tout du Basic",
      "Badge Premium orange (vu 3× plus)",
      "Top 3 des résultats find_place",
      "Multi-adresses illimitées",
      "Support WhatsApp",
    ],
  },
  {
    id: "partner",
    name: "Partner",
    price_fcfa: 50000,
    price_label: "50 000 FCFA/mois",
    perks: [
      "Tout du Premium",
      "Badge Partner violet (rang #1)",
      "Sponsoring chat dédié",
      "Account manager",
      "Mention prioritaire RDV/livraison",
    ],
  },
];

export default function ProPricingModal({ open, onClose, currentTier, onTierUpdated, userId }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  const subscribe = async (tier) => {
    if (tier.id === "free") {
      try { localStorage.setItem("civ_ai_user_tier", "free"); } catch (_) {}
      onTierUpdated && onTierUpdated("free");
      toast.success("✅ Tier Free activé");
      onClose();
      return;
    }
    if (tier.id === currentTier) {
      toast.message("Tu es déjà au tier " + tier.name);
      return;
    }
    try {
      const r = await axios.post(`${API}/payments/initiate`, {
        userId: userId || "anonymous",
        amount_fcfa: tier.price_fcfa,
        label: `Abonnement Pro · Tier ${tier.name}`,
      });
      if (r.data?.ok) {
        // Mock paiement : on enregistre direct le tier comme actif.
        try { localStorage.setItem("civ_ai_user_tier", tier.id); } catch (_) {}
        onTierUpdated && onTierUpdated(tier.id);
        toast.success(`💎 Souscription ${tier.name} simulée (CinetPay mock) · booking_id=${r.data.booking_id.slice(0,16)}…`);
        onClose();
      } else {
        toast.error(r.data?.error || "Erreur paiement");
      }
    } catch (e) {
      toast.error("Bientôt disponible — contacte-nous via WhatsApp pour souscrire dès aujourd'hui");
    }
  };

  return (
    <div
      data-testid="pro-pricing-modal"
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, zIndex: 2000,
        background: "rgba(0,0,0,0.65)", display: "flex", alignItems: "center", justifyContent: "center",
        padding: 16, animation: "civaiFadeIn 200ms ease-out",
      }}
    >
      <style>{`@keyframes civaiFadeIn { from { opacity:0; transform: translateY(8px); } to { opacity:1; transform:none; } }`}</style>
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#0f172a", color: "#f1f5f9", borderRadius: 14, padding: 22,
          maxWidth: 920, width: "100%", maxHeight: "90vh", overflowY: "auto",
          border: "1px solid rgba(255,255,255,0.1)",
          boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <h2 style={{ margin: 0, fontSize: 22 }}>💎 Boost ta visibilité AYA</h2>
          <button
            data-testid="pro-pricing-close"
            onClick={onClose}
            style={{
              background: "rgba(255,255,255,0.08)", color: "#fff", border: "none",
              padding: "4px 10px", borderRadius: 6, cursor: "pointer", fontSize: 18,
            }}
          >✕</button>
        </div>
        <p style={{ fontSize: 13, color: "#94a3b8", marginTop: 0, marginBottom: 20 }}>
          Choisis le tier qui boostera ton commerce dans les résultats du chat, des cartes et des recommandations Claude.
        </p>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))", gap: 12 }}>
          {TIERS.map((t) => {
            const isCurrent = t.id === currentTier;
            const color = TIER_COLORS[t.id];
            return (
              <div
                key={t.id}
                data-testid={`pro-tier-card-${t.id}`}
                style={{
                  background: t.highlight ? "rgba(245,158,11,0.06)" : "rgba(255,255,255,0.04)",
                  border: `1.5px solid ${t.highlight ? color : "rgba(255,255,255,0.08)"}`,
                  borderRadius: 12, padding: 16, position: "relative",
                  display: "flex", flexDirection: "column", gap: 10,
                }}
              >
                {t.highlight && (
                  <div style={{
                    position: "absolute", top: -10, right: 12, background: color, color: "#0f172a",
                    fontSize: 10, fontWeight: 800, padding: "2px 8px", borderRadius: 999,
                  }}>POPULAIRE</div>
                )}
                <div>
                  <div style={{ fontSize: 11, color, fontWeight: 700, letterSpacing: 0.8, textTransform: "uppercase" }}>{t.name}</div>
                  <div style={{ fontSize: 22, fontWeight: 700, marginTop: 4 }}>{t.price_label}</div>
                </div>
                <ul style={{ fontSize: 12, color: "#cbd5e1", padding: 0, margin: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: 5 }}>
                  {t.perks.map((p, i) => (
                    <li key={i} style={{ display: "flex", gap: 6 }}>
                      <span style={{ color }}>✓</span><span>{p}</span>
                    </li>
                  ))}
                </ul>
                <button
                  data-testid={`pro-tier-subscribe-${t.id}`}
                  onClick={() => subscribe(t)}
                  disabled={isCurrent}
                  style={{
                    marginTop: 6,
                    background: isCurrent ? "rgba(34,197,94,0.2)" : color,
                    color: isCurrent ? "#86efac" : (t.id === "premium" ? "#0f172a" : "#fff"),
                    border: "none", padding: "9px 12px", borderRadius: 8,
                    cursor: isCurrent ? "default" : "pointer",
                    fontWeight: 700, fontSize: 13,
                  }}
                >
                  {isCurrent ? "✓ Tier actuel" : t.id === "free" ? "Rester Free" : "Souscrire"}
                </button>
              </div>
            );
          })}
        </div>
        <small style={{ display: "block", marginTop: 14, fontSize: 10, color: "#64748b", textAlign: "center" }}>
          Paiement géré par CinetPay (mock dev). Pas de prélèvement réel — annulation à tout moment.
        </small>
      </div>
    </div>
  );
}
